import { Component, inject, CUSTOM_ELEMENTS_SCHEMA, OnInit } from '@angular/core';
import { RouterOutlet, Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { AppStateService } from './services/app-state.service';
import { ToastComponent } from './components/toast/toast.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { FooterComponent } from './components/footer/footer.component';
import { TokenModalComponent } from './components/modals/token-modal.component';
import { StakingModalComponent } from './components/modals/staking-modal.component';
import { LaunchpadModalComponent } from './components/modals/launchpad-modal.component';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  standalone: true,
  templateUrl: './app.html',
  styleUrl: './app.css',
  imports: [
    RouterOutlet,
    ToastComponent,
    NavbarComponent,
    FooterComponent,
    TokenModalComponent,
    StakingModalComponent,
    LaunchpadModalComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class App implements OnInit {
  public state = inject(AppStateService);
  private router = inject(Router);
  public hideNavbarFooter = false;

  constructor() {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: any) => {
      const url = event.urlAfterRedirects || '';
      this.hideNavbarFooter = url.includes('/bankless');
    });
  }

  ngOnInit() {
    console.log('====== FRONTEND CONTRACTS LOADED ======');
    console.log('Network Mode:', environment.networkMode);
    console.log('=======================================');
  }
}

